import './_header-services.scss'
import React, { useMemo } from 'react';
import { Grid, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import SearchInput from '../../../../../components/Search/SearchInput';

import { changeSearch, changeSearchOption, openModal } from '../../reducer';
import { MODALS } from '../../constants';
import { filterSearchOptionsByAccess } from '../../helpers/getters';

const ServicesHeader = ({ search, searchOptionSelected, serviceDispatch }) => {
  const { config } = useSelector((state) => state.services);
  const access = config?.access;

  const searchOptions = useMemo(() => filterSearchOptionsByAccess(config), [config])

  const onAddService = () => {
    serviceDispatch(openModal(MODALS.EDIT_SERVICE, null))
  };

  const onAddSubscription = () => {
    serviceDispatch(openModal(MODALS.EDIT_SERVICE, {
      type: 100,
    }))
  };

  const onCreateCategory = () => {
    serviceDispatch(openModal(MODALS.EDIT_CATEGORY, null))
  };

  const onOpenImportModal = () => {
    serviceDispatch(openModal(MODALS.IMPORT_SERVICES, null))
  };

  const onChangeSearch = (e) => {
    serviceDispatch(changeSearch(e.target.value))
  };

  const onChangeSearchOption = (e) => {
    const value = e.target.value === 'all' ? null : e.target.value;
    serviceDispatch(changeSearchOption(value))
  };

  return (
    <Grid fluid>
      <ul className="nav nav-tabs services-header">
        {access.add_services
          ? (
            <li className="services-header__item">
              <Button
                id="add-service"
                onClick={onAddService}
              >
                <span>Add service</span>
              </Button>
            </li>
          ) : null}
        {access.add_subscription
          ? (
            <li className="services-header__item">
              <Button
                id="add-subscription"
                onClick={onAddSubscription}
              >
                <span>Add subscription</span>
              </Button>
            </li>
          ) : null}
        {access.add_category
          ? (
            <li className="services-header__item">
              <Button
                id="create-category"
                onClick={onCreateCategory}
              >
                <span>Create category</span>
              </Button>
            </li>
          ) : null}
        {access.import_services
          ? (
            <li className="services-header__item services-header__item-import">
              <Button
                id="import-button"
                onClick={onOpenImportModal}
              >
                <span>Import services</span>
              </Button>
            </li>
          ) : null }
        <li className="pull-right">
          <SearchInput
            onChange={onChangeSearch}
            onChangeOption={onChangeSearchOption}
            value={search}
            optionSelected={searchOptionSelected}
            placeholder="Search"
            options={searchOptions}
          />
        </li>
      </ul>
    </Grid>
  );
};

ServicesHeader.propTypes = {
  search: PropTypes.string,
  searchOptionSelected: PropTypes.string,
  serviceDispatch: PropTypes.func,
};

export default ServicesHeader;
